<template>
    <v-container fluid>
        <v-form v-model="isFormValid">
            <v-card>
                <v-card-title>
                    <v-container>
                        <v-row>
                            <v-col :cols="12">{{ title }}</v-col>
                        </v-row>

                        <parameters :parameters="parameters" />

                        <v-row>
                            <v-col>
                                <v-btn v-on:click="runQuery" :disabled="!isFormValid">Build Report</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-title>

                <v-card-text>
                    <report-table :items="items" :headers="headers" :query-loading="queryLoading" :title="title" />
                </v-card-text>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import errorUtility from '../services/errorUtility'
    import { DateTime } from 'luxon'

    export default {
        components: {
            reportTable: () => import('../reports/ReportTable'),
            parameters: () => import('../reports/Parameters')
        },

        async mounted() {
            var response = await axios.get('api/RegionTypes');
            var regionTypes = response.data.items;
            var region = regionTypes.find(e => e.name === "Region");
            if (region !== null && typeof region !== "undefined") {
                this.parameters[2].fields.value = region.id;
            }
        },

        data() {
            return {
                queryLoading: false,

                headers: [],
                items: [],
                parameters: [
                    { component: () => import('./DateParameter'), fields: { name: "From", field: "from", value: this.getFilterFromDate() } },
                    { component: () => import('./DateParameter'), fields: { name: "To", field: "to", value: this.getFilterToDate() } },
                    { component: () => import('./AutocompleteParameter'), fields: { name: "Region Type", field: "regionTypeId", value: null, apiMethod: 'RegionTypes' } }
                ],
                title: "Diseases and Pests Report", 

                isFormValid: false
            }
        },

        methods: {
            async runQuery() {
                this.queryLoading = true;
                try {
                    var params = {};
                    this.parameters.forEach(e => params[e.fields.field] = e.fields.value);
                    var response = await axios.get('/api/AfflictionReport', { params });
                    var result = response.data;
                    var regionFrequencies = result.map(e => Object.keys(e.afflictionFrequencies));
                    var afflictions = [];
                    for (let i = 0; i < regionFrequencies.length; i++) {
                        for (let j = 0; j < regionFrequencies[i].length; j++) {
                            if (!afflictions.includes(regionFrequencies[i][j])) {
                                afflictions.push(regionFrequencies[i][j]);
                            }
                        }
                    }
                    var headers = [];
                    afflictions.forEach(e => headers.push({ text: e, value: this.titleToCamelCase(e) }));
                    headers.unshift({ text: "Region", value: "region" });
                    this.headers = headers;
                    var items = [];
                    for (let i = 0; i < result.length; i++) {
                        var row = {};
                        row.region = result[i].regionName;
                        for (let key in result[i].afflictionFrequencies) {
                            row[this.titleToCamelCase(key)] = result[i].afflictionFrequencies[key];
                        }
                        items.push(row);
                    }
                    this.items = items;
                }
                catch (error) {
                    errorUtility.handleServerError(error);
                }
                finally {
                    this.queryLoading = false;
                }
            },

            titleToCamelCase(string) {
                var result = string.replace(/\s+(.)/g, (match, group) => {
                    return group.toUpperCase();
                });
                return result.charAt(0).toLowerCase() + result.slice(1);
            },
            getFilterFromDate() {
                var currentDate = new Date();
                currentDate.setMonth(currentDate.getMonth() - 1);
                return currentDate.toISOString().slice(0, 10);
            },
            getFilterToDate() {
                return DateTime.local().toISODate();
            }
        },
        watch: {
            parameters: {
                deep: true,
                handler() {
                    if (this.parameters.every(e => e.fields.value != null)) {
                        this.isFormValid = true;
                    }
                }
            }
        }
    }
</script>
